import React from "react";
import {
  cloudStack,
  devopsTools,
  scriptingLanguages,
  databases,
} from "../Details";

/* Professional hover style for section headings */
const sectionHeadingClass = `
  relative inline-block
  transition-all duration-300
  hover:text-purple-400
  after:absolute after:left-0 after:-bottom-2
  after:h-[3px] after:w-0 after:bg-purple-500
  after:transition-all after:duration-300
  hover:after:w-full
`;

const Section = ({ title, items }) => (
  <section className="mt-14">
    <h2
      className={`text-2xl text-white md:text-3xl font-bold ${sectionHeadingClass}`}
    >
      {title}
    </h2>

    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-8 pt-6">
      {items.map(({ name, image }) => (
        <div
          key={name}
          className="group flex flex-col items-center justify-center
                     p-4 rounded-lg
                     bg-white/5 backdrop-blur-sm
                     border border-white/10
                     transition-all duration-300
                     hover:-translate-y-2 hover:scale-105
                     hover:border-purple-500
                     hover:shadow-lg hover:shadow-purple-500/30"
        >
          <div className="bg-white/90 rounded-md p-3 flex justify-center">
  <img
    src={image}
    alt={name}
    title={name}
    loading="lazy"
    className="h-12 object-contain
               grayscale
               transition-all duration-300
               group-hover:grayscale-0
               group-hover:scale-110"
  />
</div>


          <span className="mt-3 text-sm font-medium text-center text-white/80">
            {name}
          </span>
        </div>
      ))}
    </div>
  </section>
);

function Technologies() {
  return (
    <main className="container mx-auto max-width pt-10 pb-20">

      {/* PAGE HEADER */}
      <section>
        <h1
          className={`text-2xl text-white 
                      md:text-4xl xl:text-5xl font-bold ${sectionHeadingClass}`}
        >
          Technologies
        </h1>

        <p className="text-white/70 py-2 lg:max-w-3xl">
          A selection of technologies I’ve used in projects and hands-on development.
        </p>
      </section>

      <Section title="Cloud Stack" items={cloudStack} />
      <Section title="DevOps Tools" items={devopsTools} />
      <Section title="Scripting Languages" items={scriptingLanguages} />
      <Section title="Databases" items={databases} />
    </main>
  );
}

export default Technologies;
